// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function ($) {
	var $header = $('header');
	$(window).scroll(function () {
		if ($(window).scrollTop() > 70) {
			$header.addClass('is-scrolling');
		} else {
			$header.removeClass('is-scrolling');
		}
	});
});